if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  const observer = new MutationObserver((MutationList) => {
    for (let item of MutationList) {
      if (
        item.target.classList.contains("btn--text") ||
        item.target.localName === "product-quick-view-component"
      ) {
        BSS_B2B.observer.productSubject.notifyObserver(
          "ProductMutate",
          "ProductPriceMutate"
        );
      }

      if (
        item.target.hasAttribute &&
        item.target.hasAttribute("bss-b2b-cart-total-price")
      ) {
        cleanSubtotalText();
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  function cleanSubtotalText() {
    const subtotalElement = document.querySelector(
      "[bss-b2b-cart-total-price] .bss-b2b-price-has-vat"
    );
    if (!subtotalElement) return;
    let text = subtotalElement.textContent.trim();
    let match = text.match(/^([^\d]*[\d.,]+\s*\p{Sc}?)/u);
    if (match) {
      subtotalElement.textContent = match[1].trim();
    }
  }

  document.addEventListener("action:cart:updateCart", () => {
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  });
}

async function handleCartDrawerFooterMutation() {
  if (BSS_B2B) {
    const res = await BSS_B2B.storage.productStorage.load();
    if (res) {
      if (
        res.notExistProductIds?.length ||
        res.productIds?.length ||
        res.variantIds?.size
      ) {
        BSS_B2B.observer.productSubject.notifyObserver(
          "LazyProduct",
          "LoadedLazyProduct",
          {
            ...res,
          }
        );
      }
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    cleanSubtotalText();
  }, 2000);
});

(function waitForFormContent() {
  const intervalTime = 100;
  const maxAttempts = 50;
  let attempts = 0;

  const interval = setInterval(() => {
    const policyEle = document.querySelector(`label[for="privacy-policy"] p`);

    if (policyEle) {
      clearInterval(interval);
      const dataTranslatePolicy = {
        de: " Mit dem Absenden des Formulars versichere ich, dass ich die Datenschutzrichtlinie gelesen und akzeptiert habe",
        en: " By submitting the form, I confirm that I have read and accepted the privacy policy.",
      };

      const lang = window.location.pathname.includes("/en/") ? "en" : "de";
      document.querySelector(`label[for="privacy-policy"] p`).innerText =
        dataTranslatePolicy[lang ?? "de"];
      return;
    }

    if (++attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, intervalTime);
})();
